import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography, Button, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  getCustomerPaymentMethod,
  getLoggedinUserEmail,
} from "../../api/apiCore";
import subscriptionIcon from "../../assets/settings/settings_subscription.svg";
import logger from "../../utils/logger";

let cachedPaymentMethod: IPaymentMethod | null = null;

interface IPaymentMethod {
  brand: string;
  last4: string;
}

export default function ManagePaymentPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  const [paymentMethod, setPaymentMethod] = useState<IPaymentMethod | null>(
    null,
  );

  useEffect(() => {
    const fetchPaymentMethod = async () => {
      if (cachedPaymentMethod) {
        setPaymentMethod(cachedPaymentMethod);
        return;
      }

      try {
        const loggedInUserEmail = getLoggedinUserEmail();

        const response = await getCustomerPaymentMethod(loggedInUserEmail);

        if (response && response.data) {
          setPaymentMethod(response.data);
          cachedPaymentMethod = response.data;
        }
      } catch (error) {
        logger.error("Error searching payment method:", error);
        setPaymentMethod(null);
      }
    };

    fetchPaymentMethod();
  }, []);

  return (
    <Box
      sx={{
        maxWidth: { xs: 1200, md: 1400 },
        mx: "auto",
        display: "grid",
        justifyItems: "center",
        gap: 1,
        px: { xs: 2, md: 4 },
        py: { xs: 2, md: 3 },
      }}
    >
      {/* Header */}
      <Box sx={{ textAlign: "center", mb: 3 }}>
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 80,
            height: 80,
            mb: 2,
          }}
        >
          <img
            src={subscriptionIcon}
            alt="Subscription"
            style={{
              width: "80px",
              height: "80px",
              objectFit: "contain",
            }}
          />
        </Box>
        <Typography
          variant="h5"
          sx={{ fontWeight: 600, color: theme.palette.primary.main, mb: 1 }}
        >
          {t("setting.manage-payment")}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {/* {selectedPlan && selectedPlan !== userPlan
            ? t("pricing.changePlanDescription")
            : t("pricing.subscriptionDescription")} */}
        </Typography>
      </Box>
      {paymentMethod && (
        <Box
          sx={{
            width: "600px",
            height: "56px",
            borderRadius: "4px",
            border: "1px solid black",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 1,
          }}
        >
          <Box>
            <Typography variant="body2" color="text.secondary">
              {paymentMethod?.brand} **** **** **** {paymentMethod?.last4}
            </Typography>
          </Box>
          <Box>
            <Button
              variant="contained"
              fullWidth
              size="small"
              sx={{
                fontWeight: 600,
                py: 1.5,
                borderRadius: 2,
              }}
              onClick={() => {
                navigate(`/settings/manage-payment`);
              }}
            >
              Atualizar
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
}
